/**
 * Event requests
 */
import API from '@/api/base.js';
import CONFIG from '@/constants/config.js';
export default {
    uploadPhoto(formData,config,filename,event_id,wp_id,timestamp,date,isSolutionImage=true){
        return API.upload(`/appfileupload/upload/${CONFIG.PARAM_NAME_WP_ID}/${wp_id}/${CONFIG.PARAM_NAME_EVENT_ID}/${event_id}`,config,{
            timestamp:timestamp,
            isSolutionImage:isSolutionImage?1:0,
            date:date,
            filename:filename
        },
        formData,
        `Upload photo for WP ${wp_id} in event ${event_id}`);
    },
    uploadTeamPhoto(formData,config,filename,event_id){
        return API.upload(`/appfileupload/uploadteamfoto/${CONFIG.PARAM_NAME_EVENT_ID}/${event_id}`,config,{
            filename:filename
        },
        formData,
        `Upload team photo in event ${event_id}`);
    },
    uploadVideo(formData,config,filename,event_id,wp_id,timestamp,date,isSolutionImage=true){
        return API.upload(`/appfileupload/uploadvideo/${CONFIG.PARAM_NAME_WP_ID}/${wp_id}/${CONFIG.PARAM_NAME_EVENT_ID}/${event_id}`,config,
        {
            timestamp:timestamp,
            isSolutionImage:isSolutionImage?1:0,
            date:date,
            filename:filename
        },
        formData,
        `Upload video for WP ${wp_id} in event ${event_id}`,true);
    }
}